

















































































import { contactItems } from '@/shared/src/views/Faq/contacts.config';
import { Component } from 'vue-property-decorator';
import HomeSection from '../Home/Section.abstract';

@Component
export default class Top extends HomeSection {
  public tab = 0;

  public titles: string[] = ['Institutional', 'Consumer'];

  headersAppearence = true;

  headersRefs = {
    header: 'header',
  };

  get email(): string {
    return contactItems[1].href;
  }
}
